<template>
    <b-modal id="prePrescriptRegistModal" :title="title" size="md" @shown="onModalShown">
        <div class="search user_modal">
            <div class="table_list">
                <div class="detail">
                    <div class="title_sm pt0">
                        <h3 class="tb_title">약속상품 정보</h3>
                    </div>
                    <table class="write">
                        <colgroup>
                            <col width="100">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>약속상품명</th>
                                <td>{{promiseGoods.promise_goods_nm}}</td>
                            </tr>
                            <tr>
                                <th>상품타입</th>
                                <td>{{promiseGoods.promise_goods_type_nm}}</td>
                            </tr>
                            <tr>
                                <th>포장단위</th>
                                <td>{{promiseGoods.prepare_unit_nm}}</td>
                            </tr>
                            <tr>
                                <th>구성안내</th>
                                <td>{{promiseGoods.component_descript}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                 <h3 class="tb_title pb20 pt20">사전처방등록</h3>
                <table class="write">
                    <colgroup>
                        <col width="50">
                        <col width="100">
                        <col width="100">
                    </colgroup>
                    <thead>                
                        <tr>                                
                            <th class="bn ac">처방일자</th>
                            <th class="bn ac">사전처방량</th>
                            <th class="bn ac">처방기간</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="ac"><input type="text" class="form_control" v-model="regist_dt"></td>
                            <td class="ac">
                                <div class="form_select">
                                <b-form-select v-model="prescript_quantity" class="w100">                                                    
                                    <b-form-select-option :value="1000">1000 ea</b-form-select-option>
                                    <b-form-select-option :value="2000">2000 ea </b-form-select-option>
                                    <b-form-select-option :value="3000">3000 ea</b-form-select-option>
                                    <b-form-select-option :value="4000">4000 ea</b-form-select-option>
                                    <b-form-select-option :value="5000">5000 ea</b-form-select-option>
                                    <b-form-select-option :value="6000">6000 ea</b-form-select-option>
                                    <b-form-select-option :value="7000">7000 ea</b-form-select-option>
                                    <b-form-select-option :value="8000">8000 ea</b-form-select-option>
                                    <b-form-select-option :value="9000">9000 ea</b-form-select-option>
                                    <b-form-select-option :value="10000">10000 ea</b-form-select-option>
                                </b-form-select>
                                </div>
                            </td>
                            <td class="ac">
                                <div class="form_select">
                                    <b-form-select v-model="prescript_period" class="w100">                                                    
                                        <b-form-select-option :value="1">1 개월</b-form-select-option>
                                        <b-form-select-option :value="12">12 개월</b-form-select-option>
                                        <b-form-select-option :value="18">18 개월</b-form-select-option>
                                        <b-form-select-option :value="24">24 개월</b-form-select-option>
                                        <b-form-select-option :value="36">36 개월</b-form-select-option>
                                    </b-form-select>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button @click="fn_reg_confirm()" class="btn btn_md btn_brown">저장</b-button>
            <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
        </template>
        <AlertModal 
            :id="'alert'"
            :text="'저장되었습니다.'" 
            :btnRight="'확인'" 
            :oneBtn="false"
            :isShow="alertShow"
            :className="'btn_brown'"
            @callback="fn_modal_close"
        /> 
        <AlertModal 
            :id="'confirm'"
            :text="'저장하시겠습니까?'" 
            :btnLeft="'취소'" 
            :btnRight="'확인'" 
            :oneBtn="true"
            :isShow="comfirmAlertShow"
            :className="'btn_brown'"
            @callback="fn_alert_close"
        />
    </b-modal>

</template>

<script>
    import AlertModal from "@/modal/admin/alertModal.vue"
    import commonUtil from "@/mixin/commonUtil";
    import axios from 'axios'

    export default {
        name: 'prePrescriptRegistModal',
        mixins: [commonUtil],
        components: {
            AlertModal
        },
        props: {
            title: String,
            clinic_doctor_id : '',
            promise_goods_cd : ''
        },
        create(){
            onModalShown();
        },
        methods: {
            fn_reg_confirm(){
                this.comfirmAlertShow = true;
            },
            fn_alert_close(type){
                
                console.log("@@@@ type : "+type);

                if(type == 'hide'){
                    this.comfirmAlertShow = false;                       
                }else if(type == 'ok'){
                    this.comfirmAlertShow = false;

                    let param = new Object();
                    param.promise_goods_cd = this.promise_goods_cd;
                    param.clinic_doctor_id = this.clinic_doctor_id;
                    param.regist_dt = this.regist_dt
                    param.prescript_period = this.prescript_period
                    param. prescript_quantity = this.prescript_quantity

                    axios
                        .post("/api/user/promise/regPrePrescript", param)
                        .then((res) => {
                            this.alertShow = true;
                        })
                        .catch((err) => console.log(err));
                    }else if(type == 'close'){
                        this.alertShow = false;
                        this.$bvModal.hide("prePrescriptRegistModal"); 
                    }
            },
            onModalShown(){
                
               this.regist_dt = this.getCurrentDate();

               let param = new Object();
                param.promiseGoodsCd = this.promise_goods_cd;
                param.clinicDoctorId = this.clinic_doctor_id;

                console.log("@@@@ onModalShown param : %o",param);

                axios
                    .post("/api/user/promise/getPromiseGoodsInfo", param)
                    .then((res) => {
                        this.promiseGoods = res.data.promiseGoods;

                        console.log("@@@@ promiseGoods : %o",this.promiseGoods);
                    })
                    .catch((err) => console.log(err));
            },
            fn_modal_close(){
              this.alertShow = false;
              this.$emit('callback');
              this.$bvModal.hide("prePrescriptRegistModal");  
            }                      
        },
        data () {
            return {
                comfirmAlertShow : false,
                alertShow : false,
                promiseGoods : {
                    promise_goods_nm : '',
                    promise_goods_type_nm : '',
                    promise_goods_quantity : '',
                    prepare_unit_nm : '',
                    component_descript : ''
                },
                regist_dt : '',
                prescript_period : 24,
                prescript_quantity : 1000,
            }
        }
    }
</script>

<style>

</style>